export default __webpack_public_path__ + "static/media/cyrpto-assets-building.f92f97a2.png";